import { useTheme } from "../../../../hooks";
import ChecklistDescription from "../../ChecklistDescription";

interface ChecklistItemProps {
  text: string;
  value: string | boolean;
}

const ChecklistItem = ({ text, value }: ChecklistItemProps) => {
  const theme = useTheme() as any;
  return (
    <div>
      <div
        style={{
          display: "flex",
          gap: "8px",
          alignItems: "center",
          marginLeft: "10px",
          padding: "4px",
        }}>
        <ChecklistDescription desc={text} noscroll={true} />
        <div
          className="check"
          style={{
            width: "20px",
            height: "20px",
            border: `1px solid ${theme.colors?.main![9]}`,
            backgroundColor: value ? theme.colors!.main![9] : undefined,
          }}
        />
      </div>
      <div
        className="item-hr"
        style={{
          width: "100%",
          height: "1px",
          backgroundColor: theme.colors.main[9],
          opacity: 0.5,
        }}></div>
    </div>
  );
};
export default ChecklistItem;
